module.exports = __webpack_public_path__ + "static/media/porto.ec6b7e81.webp";